import { AxiosRequestConfig } from 'axios';
import request from 'src/services/request';
import { IUser } from '@src/models';

export function applyForJob({ jobId, payload }: any, config?: AxiosRequestConfig) {
  return request.post(`/anonymous_jobs/${jobId}`, payload, config);
}

export function simpleApplyForJob({ jobId, from_careers_page }: any) {
  return request.post(`/anonymous_jobs/${jobId}/simple_apply`, { from_careers_page });
}

type IUploadCVResponse = {
  filename: string;
  resume_url: string;
};

export function uploadCV({ payload }) {
  return request.post<void, IUploadCVResponse>('/anonymous_jobs/resume', payload);
}

export function parseCV({ payload }: { payload: { resume_url: string } }) {
  return request.post<void, IUser>('/anonymous_jobs/parse_resume', payload);
}

export function uploadCustomFileAnswer({ file }) {
  return request.post(`/anonymous_jobs/answer_file`, file);
}
